// extracted by mini-css-extract-plugin
export default {"bodyText":"_b9f54604"};